<template>
  <Transition name="fade">
    <div v-if="videoDesc.length">
      <div class="de-top" v-for="item in videoDesc" :key="item.id">
        <div class="de-img">
          <img v-lazy="item.coverImg" alt="" />
          <div class="pr-tag">
            <i class="pr-year" title="课程年份">{{ item.grade.grYear }}</i>
            <i class="pr-way" title="学习方式">{{
              item.grade.prTeachWayName
            }}</i>
          </div>

          <p class="grade" v-if="item.grade.grName.length <= 4">
            {{ item.grade.grName }}
          </p>
          <p class="grade1" v-if="item.grade.grName.length > 4">
            {{ item.grade.grName }}
          </p>
        </div>

        <div class="video-desc">
          <div class="title">
            <h2 :title="item.leName">
              {{ item.grade.grYear }}{{ item.leName }}
            </h2>
          </div>
          <div class="contain">
            <h4>包含课程：</h4>
            <div class="con-video">
              <i v-for="video in item.grade.prVideoName" :key="video.index">{{
                video
              }}</i>
            </div>
          </div>
          <div class="elec">
            <h4>电子资料：</h4>
            <div class="elec-edi">
              <i v-for="pdf in item.grade.prPdfName" :key="pdf.index">{{
                pdf
              }}</i>
            </div>
          </div>
          <div class="serve">
            <h4>增值服务：</h4>
            <div class="ser">
              <i title="课程有效期/承诺" class="teach-time">{{
                item.grade.prTeachTimeName
              }}</i>
              <i
                v-for="service in item.grade.prServiceName"
                :key="service.index"
                >{{ service }}</i
              >
            </div>
          </div>
          <div class="price">
            <div class="old-price">
              <h3>原价：</h3>
              <h3>{{ item.grade.grPrice }}</h3>
            </div>
            <div class="sale-price">
              <h3>优惠价：</h3>
              <h3>{{ item.grade.salePrice }}</h3>
            </div>
            <!--  <div class="video-num">
              <el-icon><Avatar /></el-icon>
              <h5>1980人学习过</h5>
            </div> -->
            <RouterLink
              target="_blank"
              @click="toBuy(item.id, item.clID)"
              :to="`/user/checkout?id=${item.id}&type=video`"
            >
              <el-button size="large" type="danger">点击购买</el-button>
            </RouterLink>
            <RouterLink
              target="_blank"
              :to="`/video/videoplay?id=${item.id}&clID=${item.clID}&tvideoId=${videoDesc[0]?.tvideo[0]?.tvideos[0]?.tvideoId}`"
            >
              <el-button
                v-if="item.tvideo && item.tvideo.length"
                size="large"
                type="danger"
                plain
                >免费试听
              </el-button>
            </RouterLink>
            <ContactMe :videoDesc="videoDesc" />
          </div>

          <div class="share">
            <h4>分享到</h4>
            <img src="../../../../public/icon/微信logo.png" alt="" />
            <img src="../../../../public/icon/QQlogo.png" alt="" />
            <img src="../../../../public/icon/QQ空间logo.png" alt="" />
            <img src="../../../../public/icon/微博logo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <VideoDescSkeleton v-else />
  </Transition>
</template>

<script>
import { watch, ref } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import VideoDescSkeleton from "./video-desc-skeleton.vue";
import ContactMe from "@/components/contact-me.vue";
export default {
  name: "VideoDesc",
  components: {
    VideoDescSkeleton,
    ContactMe,
  },
  props: {
    videoData: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const videoDesc = ref([]);
    const store = useStore();
    watch(
      () => props.videoData,
      (newDta, OldData) => {
        videoDesc.value = newDta.map((item) => {
          return {
            coverImg: "/web/" + item.coverImg,
            leName: item.leName,
            grade: item.grade[0],
            tvideo: item.tvideo,
            clID: item.clID,
            id: item._id,
            maID: item.maID,
          };
        });
      }
    );

    const toBuy = () => {
      const { profile } = store.state.user;
      if (!profile.token) {
        ElMessage({
          message: "购买前请先登录",
          type: "warning",
        });
      }
    };
    return { toBuy, videoDesc, ContactMe };
  },
};
</script>

<style lang="less" scoped>
.de-top {
  display: flex;
  align-items: center;
  margin-top: 15px;
  height: 410px;
  border-radius: 5px;
  background: #fff;
  .de-img {
    position: relative;
    display: flex;
    justify-content: center;
    width: 550px;
    height: 380px;
    .pr-tag {
      display: inline-block;
      position: absolute;
      top: 24px;
      right: 4px;
      .pr-way {
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
      }
      .pr-year {
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
        margin-right: 5px;
      }
    }

    img {
      align-self: center;
      margin-left: 10px;
      width: 500px;
      height: 335px;
      border-radius: 5px;
    }
    .grade {
      position: absolute;
      font-weight: bold;
      font-size: 30px;
      top: 72.9%;
      left: 41%;
    }
    .grade1 {
      position: absolute;
      font-weight: bold;
      font-size: 30px;
      top: 72.9%;
      left: 36.3%;
    }
  }
  .video-desc {
    width: 690px;
    margin: 0px 10px 5px 15px;
    position: relative;
    .title {
      margin-top: 5px;
      //height: 45px;
      h2 {
        max-height: 75px;
        width: 695px;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .contain {
      display: flex;
      align-items: center;
      width: 100%;
      //height: 75px;
      max-height: 115px;
      flex-wrap: wrap;
      border-bottom: 1px dashed #ebebeb;
      h4 {
        width: 70px;
      }
      .con-video {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 620px;
        //padding-top: 10px;
        i {
          display: block;

          //width: 85px;
          padding-left: 5px;
          padding-right: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin: 3px 3px 3px 3px;
          color: @shColor;
          background-color: rgb(245, 245, 245);
          border-radius: 5px;
        }
      }
    }
    .elec {
      display: flex;
      align-items: center;
      max-height: 45px;
      //height: 40px;
      border-bottom: 1px dashed #ebebeb;
      h4 {
        width: 70px;
      }
      .elec-edi {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 620px;
        //padding-top: 10px;
        i {
          display: block;

          //width: 85px;
          padding-left: 5px;
          padding-right: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin: 3px 3px 3px 3px;
          color: @shColor;
          background-color: rgb(245, 245, 245);
          border-radius: 5px;
        }
      }
    }
    .serve {
      display: flex;
      align-items: center;
      //max-height: 75px;
      //background: #666;
      border-bottom: 1px dashed #ebebeb;
      h4 {
        width: 70px;
      }
      .ser {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 620px;
        //padding-top: 10px;
        i {
          display: block;

          //width: 85px;
          padding-left: 5px;
          padding-right: 5px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin: 3px 3px 3px 3px;
          color: @shColor;
          background-color: rgb(245, 245, 245);
          border-radius: 5px;
        }
        .teach-time {
          font-weight: bold;
          color: #e6395e;
          background-color: #f5f5f5;
        }
      }
    }
    .price {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 50px;
      width: 690px;
      margin: 0 auto;
      .old-price {
        display: flex;
        align-items: center;
        h3 {
          text-decoration: line-through;
        }
      }
      .sale-price {
        display: flex;
        align-items: center;
        h3 {
          color: red;
        }
      }
      .video-num {
        display: flex;
        align-items: center;
        color: #666;
      }
    }

    .share {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 8px;
      border-radius: 8px;
      height: 35px;
      //background: #f5f5f5;
      h4 {
        margin-right: 15px;
        color: #666;
      }
      img {
        width: 30px;
        height: 30px;
        margin-right: 15px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
